import { TrailerType } from '@trucksmarter/shared';

/** Trailers that are filterable in the search UI. */
export const FILTERABLE_TRAILER_TYPE_OPTIONS: TrailerType[] = [
  TrailerType.Van,
  TrailerType.Reefer,
  TrailerType.Flatbed,
  TrailerType.PowerOnly,
  TrailerType.StepDeck,
  TrailerType.Conestoga,
  TrailerType.Container,
  TrailerType.BoxTruck,
  TrailerType.CargoVan,
  TrailerType.GooseNeck,
  TrailerType.HotShot,
];

export const VALID_FILTERABLE_TRAILER_TYPE_OPTIONS: Partial<
  Record<TrailerType, boolean>
> = {
  [TrailerType.Van]: true,
  [TrailerType.Reefer]: true,
  [TrailerType.Flatbed]: true,
  [TrailerType.PowerOnly]: true,
  [TrailerType.StepDeck]: true,
  [TrailerType.Conestoga]: true,
  [TrailerType.Container]: true,
  [TrailerType.BoxTruck]: true,
  [TrailerType.CargoVan]: true,
  [TrailerType.GooseNeck]: true,
  [TrailerType.HotShot]: true,
};

export const DEFAULT_TRAILER_TYPES: TrailerType[] = [];
